import Aes from './aes'
import md5 from 'crypto-js/md5'

export function setData(data){
    // console.log(data)
    data['timestamp'] = Date.parse(new Date()) / 1000
    var data_string = arrToStr(data, '&')
    // console.log(data_string)
    // data['signature'] = md5(Aes.encrypt(data_string)).toString()
    data['signature'] = Aes.encrypt(md5(data_string)).toString()
    // console.log(data)
    // console.log(md5(data_string))
    // console.log(Aes.encrypt(md5(data_string)).toString())
    return data
}

function arrToStr(arr, symbol) {
    var temparr = [];
    var k = 0;
    for (var key in arr) {
      temparr[k] = key + '=' + arr[key];
      k++;
    }
    var newarr = temparr.sort();
    var str = '';
    var len = newarr.length;
    for (var i = 0; i < len; i++) {
      if (i == len - 1) {
        str += newarr[i];
      } else {
        str += newarr[i] + symbol;
      }
    }
    return str;
  }


// WEBPACK FOOTER //
// ./src/util/setData.js